export default __webpack_public_path__ + "static/media/su-char-icon.5a5a1b5d.png";